var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-box",staticStyle:{"width":"98%","height":"83%"},attrs:{"id":"eChartLine"}})
}
var staticRenderFns = []

export { render, staticRenderFns }